import { useSelector } from 'react-redux'
import { getPermissionBlockColor, getPermissionColorGroupBlockColor, updatePermission } from '../../Helper/permissionHelper'
import { primary_color } from '../../Helper/uiHelper'

const PermissionColorFilter = ({
  text = 'View',
  viewPermission,
  item,
  isMainPageViewEnabled,
  role_id,
  isCreatingNewRole,
  onClickPermissionForNewRole,
  selectedPermissionToCreateRole,
}) => {
  const Queue = useSelector((state) => state.Queue.queues)
  let { bgColor, textColor, border, isDisabled } = getPermissionColorGroupBlockColor(
    item,
    viewPermission,
    isMainPageViewEnabled,
    role_id,
    isCreatingNewRole,
    selectedPermissionToCreateRole
  )

  
  return (
    <span
      className={`badge badge-pill permission-color-filter-block ${!bgColor?.includes('#') && 'badge-' + bgColor}`}
      onClick={() => {
        if (isCreatingNewRole) {
          onClickPermissionForNewRole(item?.permission_id)
        } else {
          updatePermission(role_id, item?.permission_id, item?.enabled)
        }
      }}
      style={{
        backgroundColor: bgColor?.includes('#') && bgColor,
        border: border,
        cursor: !isDisabled && 'pointer',
        pointerEvents: isDisabled && 'none',
        color: textColor,
      }}>
      {text}
    </span>
  )
}

export default PermissionColorFilter
